// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getAuth } from 'firebase/auth'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_APIKEY_VARIABLE,
  authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN_VARIABLE,
  projectId: process.env.REACT_APP_FIREBASE_PROJECTID_VARIABLE,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGEBUCKET_VARIABLE,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGINGSENDERID_VARIABLE,
  appId: process.env.REACT_APP_FIREBASE_APPID_VARIABLE,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENTID_VARIABLE
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
const analytics = getAnalytics(app)
const auth = getAuth()

export { app, analytics, auth }
